export const environment = {
  production: true,
  test: false,
  graphqlEndpoint: '/v1/graphql',
  // Ngưỡng thanh toán tối thiểu để được rút tiền (VND)
  withdrawalLimit: 500000,
  // Phí rút tiền (%)
  withdrawalFeePercent: 10,
  // Danh sách email được phép vào trang admin (chỉ để ẩn/hiện UI, không phải bảo mật)
  adminEmails: ['hiepxanh@gmail.com', 'cthuong252@gmail.com'],
};
